import React, { useState, useEffect } from 'react';
import './NewHomeUMS.scss';
import Software from '../../images/new_ui/Softwareicon.svg';
import issuedate from '../../images/new_ui/Issuedate.svg';
import Expdate from '../../images/new_ui/Expdate.svg';
import Statusimg from '../../images/new_ui/Statusimg.svg';
import filter from '../../images/new_ui/filter_con.svg';
import uparrow from '../../images/new_ui/uparrow_con.svg';
import { ReactComponent as TableRight } from "../../images/new_ui/Licenselistimgnew.svg";
import axios from "axios";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { sidebarReducer } from "../../Redux/store";
import { userReducer } from "../../Redux/store";
import { Route, Navigate, useNavigate } from "react-router-dom";
import { Menu, MenuItem } from "@mui/material";
import downarrow from '../../images/new_ui/downarrow_con.svg';

function NewHomeUMS() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [licenses, setLicenses] = useState([]);
    const [softwareFilterOpen, setSoftwareFilterOpen] = useState(false);
    const [filteredSoftwaretype, setFilteredSoftwaretype] = useState([]);
    const [sortDirection, setSortDirection] = useState('asc');
    const [statusFilterOpen, setStatusFilterOpen] = useState(false);
    const [sortColumn, setSortColumn] = useState(null);

    useEffect(() => {
        getUsersList();
    }, []);

    async function getUsersList() {
        dispatch(sidebarReducer.apiLoad(true));
        await axios
            .get(
                "/licensedetails/CompanyLicenselistbyid/" +
                JSON.parse(sessionStorage.getItem("userdata")).te_companyid,
                {
                    headers: {
                        Authorization:
                            "Bearer" + " " + sessionStorage.getItem("access_token"),
                    },
                }
            )
            .then((response) => {
                // console.log(" response list users", response);
                setLicenses(response.data.data);
                if (response.status === 200) {
                    dispatch(sidebarReducer.apiLoad(false));
                } else if (response.status !== 200) {
                    dispatch(sidebarReducer.stringUpdate("AppDown"));
                }
            })
            .catch((err) => {
                dispatch(sidebarReducer.stringUpdate("AppDown"));
            });
    }

    const handleRowClick = (te_prepid) => {
        navigate(`/home-ums/?te_prepid=` + te_prepid);
    };

    const handleSoftwareFilter = (softwareType) => {
        if (softwareType === "All") {
            setFilteredSoftwaretype(licenses);
        } else {
            const filteredData = licenses.filter(
                (license) => license.master_pack.te_bundlename === softwareType
            );
            setFilteredSoftwaretype(filteredData);
        }
        setSoftwareFilterOpen(false);
    };

    const getUniqueSoftware = () => {
        const uniqueSoftware = ['All', ...new Set(licenses.map(license => license.master_pack.te_bundlename))];
        return uniqueSoftware;
    };

    const getUniqueStatus = () => {
        const uniqueStatus = ['All', ...new Set(licenses.map(license => license.te_islicenseactivated ? "Activated" : "Not Activated"))];
        return uniqueStatus;
    };

    const handleStatusFilter = (status) => {
        if (status === "All") {
            setFilteredSoftwaretype(licenses);
        } else {
            const filteredData = licenses.filter(
                (license) => (license.te_islicenseactivated ? "Activated" : "Not Activated") === status
            );
            setFilteredSoftwaretype(filteredData);
        }
        setStatusFilterOpen(false);
    };

    const handleSort = (column) => {
        if (sortColumn === column) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortColumn(column);
            setSortDirection('asc');
        }
    };

    const getArrowImage = (column) => {
        if (sortColumn === column) {
            return sortDirection === 'asc' ? uparrow : downarrow;
        }
        return uparrow;
    };

    const sortData = (data) => {
        if (sortColumn) {
            return [...data].sort((a, b) => {
                const valueA = new Date(a[sortColumn]);
                const valueB = new Date(b[sortColumn]);
                return sortDirection === 'asc' ? valueA - valueB : valueB - valueA;
            });
        }
        return data;
    };

    useEffect(() => {
        setFilteredSoftwaretype(licenses);
    }, [licenses]);

    return (
        <div className='software-list'>
            <div className="container">
                <div className="software-list-container">
                    <h5>License List</h5>
                    <br></br>
                    <div style={{ height: "93%" }}>
                        <div className="container-fluid g-0 table-custom" >
                            <div className="table-wrapper-scroll-y user-list-table" >
                                <>
                                    <table stickyHeader aria-label="sticky table">
                                        <thead>
                                            <tr>
                                                <th id="software-filter-icon">
                                                    <div onClick={() => setSoftwareFilterOpen(!softwareFilterOpen)}>
                                                        <img src={Software} className="name-icon" alt="Software" />
                                                        <span className='text-heading'>Software</span>
                                                        <img className="filter-icon" src={filter} alt="Filter" />
                                                    </div>
                                                    <Menu
                                                        anchorEl={document.getElementById('software-filter-icon')}
                                                        open={softwareFilterOpen}
                                                        onClose={() => setSoftwareFilterOpen(false)}
                                                    >
                                                        {getUniqueSoftware().map((item, index) => (
                                                            <MenuItem key={index} onClick={() => handleSoftwareFilter(item)}>
                                                                {item}
                                                            </MenuItem>
                                                        ))}
                                                    </Menu>
                                                </th>
                                                <th onClick={() => handleSort('te_licenseactivationdate')}>
                                                    <img src={issuedate} className="size-icon" alt="Issue Date" />
                                                    <span className='text-heading'>Issue Date</span> 
                                                    <img
                                                        className="uparrow-icon"
                                                        src={getArrowImage('te_licenseactivationdate')}
                                                        alt={sortDirection === 'asc' ? "Sort Ascending" : "Sort Descending"}
                                                    />
                                                </th>
                                                <th onClick={() => handleSort('te_licenseexpirationdate')}>
                                                    <img src={Expdate} className="type-icon" alt="Expiry Date" /> 
                                                    <span className='text-heading'>Expiry Date</span>
                                                    <img 
                                                        className="filter-icon" 
                                                        src={getArrowImage('te_licenseexpirationdate')}
                                                        alt={sortDirection === 'asc' ? "Sort Ascending" : "Sort Descending"}
                                                    />
                                                </th>
                                                <th id="status-filter-icon">
                                                    <div onClick={() => setStatusFilterOpen(!statusFilterOpen)}>
                                                        <img src={Statusimg} className="date-icon"  />
                                                        <span className='text-heading'>Status</span>
                                                        <img
                                                            className="filter-icon"
                                                            src={filter}
                                                        />
                                                    </div>
                                                    <Menu
                                                        anchorEl={document.getElementById('status-filter-icon')}
                                                        open={statusFilterOpen}
                                                        onClose={() => setStatusFilterOpen(false)}
                                                    >
                                                        {getUniqueStatus().map((item, index) => (
                                                            <MenuItem key={index} onClick={() => handleStatusFilter(item)}>
                                                                {item}
                                                            </MenuItem>
                                                        ))}
                                                    </Menu>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {sortData(filteredSoftwaretype).map((license) => (
                                                <tr key={license.te_lmsid}>
                                                    <td style={{ cursor: "pointer",textDecoration: "underline" ,textUnderlineOffset: "4px"}} 
                                                    onClick={() => handleRowClick(license.te_prepid)}>{license.master_pack.te_bundlename}</td>
                                                    <td>{new Date(license.te_licenseactivationdate).toLocaleDateString()}</td>
                                                    <td>{new Date(license.te_licenseexpirationdate).toLocaleDateString()}</td>
                                                    <td>{license.te_islicenseactivated ? "Active" : "Inactive"}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </>
                            </div>
                            <div style={{ alignContent: "end" }} >
                                <TableRight className='image-styling' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NewHomeUMS;